import { type MoneyMapRuleType } from '@fruitful/types';
import { PieChart } from 'react-native-gifted-charts';
import { useThemeColors, View } from 'smoothie';

import {
    type IncomeSplitMonthlyCategoryProgress,
    IncomeSplitOverviewColors,
} from '../types/IncomeSplitOverviewTypes';

export const IncomeSplitProgressDonut = ({
    percentage,
    previousProgress,
    moneyMapRuleType,
}: {
    percentage: number;
    previousProgress?: IncomeSplitMonthlyCategoryProgress;
    moneyMapRuleType: MoneyMapRuleType;
}) => {
    const { getColor } = useThemeColors();
    const resolveColor = (color: string) =>
        color.startsWith('$') ? getColor(color) : color;
    let overfund = 0;
    if (percentage > 1) {
        overfund = percentage - 1;
    }

    const colors = IncomeSplitOverviewColors[moneyMapRuleType];

    return (
        <View width={78} height={78} position="relative">
            <PieChart
                strokeWidth={0}
                radius={39}
                innerRadius={29}
                innerCircleColor={getColor('$gray200')}
                data={[
                    {
                        color: resolveColor(colors.backgroundPrevious),
                        value: previousProgress?.percentage ?? 0,
                    },
                    {
                        color: resolveColor(colors.background),
                        value:
                            Math.min(percentage, 1) -
                            (previousProgress?.percentage ?? 0),
                    },
                    {
                        color: getColor('$gray400'),
                        value: 1 - percentage,
                    },
                ]}
                labelsPosition="outward"
                donut={true}
            />
            {overfund > 0 && (
                <View
                    position="absolute"
                    top={0}
                    left={0}
                    right={0}
                    bottom={0}
                    alignItems="center"
                    justifyContent="center"
                >
                    <PieChart
                        strokeWidth={0}
                        radius={39}
                        innerRadius={29}
                        innerCircleColor={getColor('$gray200')}
                        data={[
                            {
                                color: resolveColor(colors.backgroundOverfund),
                                value: overfund,
                            },
                            {
                                color: 'transparent',
                                value: 1 - overfund,
                            },
                        ]}
                        labelsPosition="outward"
                        donut={true}
                    />
                </View>
            )}
        </View>
    );
};
